"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlitzSplashScreenDesktop = void 0;
var _pixi = require("pixi.js");
var _PageOne = require("./PageOne");
var _PageTwo = require("./PageTwo");
var _core = require("@dragon/core");
var _pixiGame = require("@dragon/pixi-game");
var _gsap = _interopRequireDefault(require("gsap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BlitzSplashScreenDesktop = exports.BlitzSplashScreenDesktop = /*#__PURE__*/function (_CustomPixiContainer) {
  function BlitzSplashScreenDesktop(parentContainer, locale) {
    var _this$dialogContainer;
    var _this;
    _classCallCheck(this, BlitzSplashScreenDesktop);
    _this = _callSuper(this, BlitzSplashScreenDesktop);
    _defineProperty(_this, "bgRect", void 0);
    _defineProperty(_this, "currentResolve", void 0);
    _defineProperty(_this, "_logo", void 0);
    _defineProperty(_this, "_checkBoxContainer", void 0);
    _defineProperty(_this, "dialogContainer", void 0);
    _defineProperty(_this, "clickOverlay", void 0);
    _defineProperty(_this, "_textContinue", void 0);
    _defineProperty(_this, "_pages", []);
    _defineProperty(_this, "_currentPage", void 0);
    _defineProperty(_this, "_pagnators", void 0);
    _defineProperty(_this, "unsub1", void 0);
    _defineProperty(_this, "unsub2", void 0);
    _defineProperty(_this, "unsub3", void 0);
    _defineProperty(_this, "_button", void 0);
    _defineProperty(_this, "logoInterval", void 0);
    _defineProperty(_this, "styleMap", void 0);
    _defineProperty(_this, "localeStyleMap", {
      "default": {
        header: {
          fontSize: 44,
          fill: 0xffffff,
          fontFamily: ["LocaleFontBold", "InterBold"]
        },
        subHeader: {
          fontSize: 24,
          fill: 0xffffff,
          fontFamily: ["LocaleFontBold", "InterMedium"]
        },
        detail: {
          fontSize: 16,
          fill: 0xffffff,
          fontFamily: ["LocaleFontRegular", "InterRegular"],
          align: "center"
        },
        "continue": {
          fill: ["#FFFFFF", "#FFE73C", "#BB922A"],
          fillGradientStops: [0.1, 0.6, 0.9],
          fontSize: 34,
          align: "center",
          fontFamily: ["LocaleFontBold", "InterBold"]
        },
        hide: {
          fontSize: 16,
          fill: 0xffffff,
          fontFamily: ["LocaleFontRegular", "InterRegular"],
          align: "center"
        }
      },
      ja_JP: {
        header: {
          fontSize: 44,
          fill: 0xffffff,
          fontFamily: ["NotoSansJPBold", "InterBold"]
        },
        subHeader: {
          fontSize: 24,
          fill: 0xffffff,
          fontFamily: ["NotoSansJPBold", "InterBold"]
        },
        detail: {
          fontSize: 16,
          fill: 0xffffff,
          fontFamily: ["NotoSansJPRegular", "InterRegular"],
          align: "center"
        },
        "continue": {
          fill: ["#FFFFFF", "#FFE73C", "#BB922A"],
          fillGradientStops: [0.1, 0.6, 0.9],
          fontSize: 34,
          align: "center",
          fontFamily: ["NotoSansJPBold", "InterBold"]
        },
        hide: {
          fontSize: 16,
          fill: 0xffffff,
          fontFamily: ["NotoSansJPRegular", "InterRegular"],
          align: "center"
        }
      }
    });
    _defineProperty(_this, "showPage", function (i) {
      _this._currentPage = i;
      for (var index = 0; index < _this._pages.length; index++) {
        _this._pages[index].visible = false;
        _this._pagnators[index].texture = _pixi.Texture.from("bspl_select.png");
      }
      _this._pagnators[i].texture = _pixi.Texture.from("bspl_select_active.png");
      _this._pages[i].visible = true;
    });
    _defineProperty(_this, "nextPage", function () {
      _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, "uiclick"));
      _this._currentPage++;
      _this.showPage(Math.abs(_this._currentPage % _this._pages.length));
    });
    _defineProperty(_this, "prevPage", function () {
      _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, "uiclick"));
      _this._currentPage--;
      if (_this._currentPage < 0) _this._currentPage = _this._pages.length - 1;
      _this.showPage(Math.abs(_this._currentPage % _this._pages.length));
    });
    _defineProperty(_this, "handleResize", function (c) {
      _this.scale.set(1);
      _this.clickOverlay.clear();
      _this.clickOverlay.beginFill(0x000000, 0.6);
      _this.clickOverlay.drawRoundedRect(0, 0, c.width, c.height, 0);
      _this._logo.y = -340;
      _this._checkBoxContainer.position.set(-106, 231 + 80);
      _this._button.y = 150 + 100;
      _this._button.x = 0;
      _this._textContinue.y = 141 + 100;
      _this._textContinue.x = 0;
      _gsap["default"].killTweensOf(_this._button);
      _gsap["default"].to([_this._button.scale, _this._textContinue.scale], {
        duration: 1,
        x: 0.97,
        y: 0.97,
        repeat: -1,
        yoyo: true
      });
      _this.dialogContainer.y = c.height / 2;
      _this.dialogContainer.x = c.width / 2;
      switch (c.channel) {
        case _core.Channel.Desktop:
          {
            _this.dialogContainer.scale.set(c.scaleFactor);
            break;
          }
        case _core.Channel.Mobile:
          {
            switch (c.orientation) {
              case _core.Orientation.Portrait:
                {
                  _this.dialogContainer.scale.set(1);
                  _this.dialogContainer.y -= c.height * 0.1;
                  _this.dialogContainer.scale.set(c.width / 829); // fixed width, meassured in development
                  break;
                }
              case _core.Orientation.Landscape:
                {
                  _this.dialogContainer.scale.set(c.scaleFactor);
                  break;
                }
            }
            break;
          }
      }
    });
    _defineProperty(_this, "hide", function () {
      _gsap["default"].to(_this, {
        duration: 0.3,
        alpha: 0
      });
      setTimeout(function () {
        clearInterval(_this.logoInterval);
        _this.visible = false;
        _this.unsub1();
        for (var index = 0; index < _this._pages.length; index++) {
          _this._pages[index].destroy();
        }
        _this.destroy();
        _this.clickOverlay.destroy();
      }, 300);
      if (_this.currentResolve) _this.currentResolve();
    });
    _defineProperty(_this, "show", function () {
      _core.CORE.dispatch({
        type: _core.BLITZ_SHOW_SPLASH
      });
      _this.visible = true;
      _gsap["default"].to(_this, {
        duration: 0.5,
        alpha: 1
      });
    });
    _this.alpha = 0;
    _this.styleMap = _this.localeStyleMap[locale] != undefined ? _this.localeStyleMap[locale] : _this.localeStyleMap["default"];
    _this.dialogContainer = new _pixiGame.CustomPixiContainer();

    //add click overlay.
    _this.clickOverlay = new _pixi.Graphics();
    _this.clickOverlay.clear();
    _this.clickOverlay.interactive = true;
    _this.clickOverlay.on("mousedown", function () {
      _core.CORE.dispatch({
        type: _core.HIDE_SPLASH_SCREEN
      });
    });
    _this.clickOverlay.on("touchstart", function () {
      _core.CORE.dispatch({
        type: _core.HIDE_SPLASH_SCREEN
      });
    });
    _this.addChild(_this.clickOverlay);

    // Temporary background.
    _this.bgRect = new _pixi.Graphics();
    // this.dialogContainer.addChild(this.bgRect)
    _this.bgRect.visible = false;
    _this._logo = new _pixi.Sprite(_pixi.Texture.from("blitz_logo.png"));
    _this._logo.anchor.set(0.5);
    _this._logo.scale.set(1.4);
    _this.dialogContainer.addChild(_this._logo);

    // prevents overlay click from triggering inside the dialog.
    _this.dialogContainer.interactive = true;
    _this.dialogContainer.on("mousedown", function (e) {
      e.stopPropagation();
    });
    _this.dialogContainer.on("touchstart", function (e) {
      e.stopPropagation();
    });
    _this._button = new _pixi.Sprite(_pixi.Texture.from("bspl_button.png"));
    _this._button.anchor.set(0.5);
    _this._button.interactive = true;
    _this._button.on("mousedown", function (e) {
      e.stopPropagation();
      _core.CORE.dispatch({
        type: _core.BLITZ_CLOSE_SPLASH
      });
      _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, "uiclick"));
    });
    _this._button.on("touchstart", function (e) {
      e.stopPropagation();
      _core.CORE.dispatch({
        type: _core.BLITZ_CLOSE_SPLASH
      });
      _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, "uiclick"));
    });
    _this.dialogContainer.addChild(_this._button);
    _this._textContinue = new _pixi.Text(_core.CORE.translate("splashDesktopTextContinue"),
    //"PRESS ANYWHERE TO HIDE OR SPIN TO PLAY",
    _this.styleMap["continue"]);
    _this._textContinue.anchor.set(0.5);
    _this.dialogContainer.addChild(_this._textContinue);

    //#region  CheckBox
    _this._checkBoxContainer = new _pixi.Container();
    _this._checkBoxContainer.name = "CheckBoxContainer";
    var boxSprite = new _pixi.Sprite(_pixi.Texture.from("bspl_box.png"));
    var checkSprite = new _pixi.Sprite(_pixi.Texture.from("bspl_box_checked.png"));
    //   checkSprite.position.set(-8, -10)
    _this.unsub3 = _core.CORE.subscribe("config.blitzSplashScreenHide", function (e) {
      if (e) checkSprite.visible = true;else checkSprite.visible = false;
    });
    var cbText = new _pixi.Text(_core.CORE.translate("splashDesktopDontShowAgain"),
    //"Don't show again",
    _this.styleMap.hide);
    cbText.x = 36;
    cbText.y = 2;
    _this._checkBoxContainer.interactive = true;
    _this._checkBoxContainer.on("mousedown", function (e) {
      e.stopPropagation();
      _core.CORE.dispatch({
        type: _core.BLITZ_SPLASH_SCREEN_HIDE_TOGGLE
      });
      _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, "uitoggle"));
    });
    _this._checkBoxContainer.on("touchstart", function (e) {
      e.stopPropagation();
      _core.CORE.dispatch({
        type: _core.BLITZ_SPLASH_SCREEN_HIDE_TOGGLE
      });
      _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, "uitoggle"));
    });
    _this._checkBoxContainer.addChild(boxSprite, checkSprite, cbText);
    _this.dialogContainer.addChild(_this._checkBoxContainer);
    //#endregion

    // Pages
    _this._pages.push(new _PageOne.PageOne(_this.styleMap, locale), new _PageTwo.PageTwo(_this.styleMap, locale));
    (_this$dialogContainer = _this.dialogContainer).addChild.apply(_this$dialogContainer, _toConsumableArray(_this._pages));
    _this.unsub1 = _core.CORE.subscribe("config.screenSize", _this.handleResize);
    _this.addChild(_this.dialogContainer);
    parentContainer.addChild(_this);

    //#region pagnation
    var pagContainer = new _pixiGame.CustomPixiContainer();
    _this._pagnators = [];
    var _loop = function _loop(index) {
        pag = new _pixi.Sprite();
        pag.anchor.set(0.5);
        pag.x = 25 * index;
        _this._pagnators.push(pag);
        pagContainer.addChild(pag);
        pag.interactive = true;
        pag.on("mousedown", function (e) {
          _this.showPage(index);
          e.stopPropagation();
        });
        pag.on("touchstart", function (e) {
          _this.showPage(index);
          e.stopPropagation();
        });
      },
      pag;
    for (var index = 0; index < _this._pages.length; index++) {
      _loop(index);
    }
    pagContainer.setAnchor(0.5);
    pagContainer.y = 170;
    _this.dialogContainer.addChild(pagContainer);
    // prevents overlay click from triggering inside the dialog.
    _this.dialogContainer.interactive = true;
    _this.dialogContainer.on("mousedown", function (e) {
      _this.nextPage();
      e.stopPropagation();
    });
    _this.dialogContainer.on("touchstart", function (e) {
      _this.nextPage();
      e.stopPropagation();
    });
    var next = new _pixi.Sprite(_pixi.Texture.from("bspl_page.png"));
    var prev = new _pixi.Sprite(_pixi.Texture.from("bspl_page.png"));
    prev.scale.set(-1, 1);
    prev.interactive = next.interactive = true;
    next.y = prev.y = -82;
    prev.x = -420;
    next.x = 420;
    prev.on("mousedown", function (e) {
      _this.prevPage();
      e.stopPropagation();
    });
    prev.on("touchstart", function (e) {
      _this.prevPage();
      e.stopPropagation();
    });
    next.on("mousedown", function (e) {
      _this.nextPage();
      e.stopPropagation();
    });
    next.on("touchstart", function (e) {
      _this.nextPage();
      e.stopPropagation();
    });
    _this.dialogContainer.addChild(next, prev);
    //#endregion
    _this.showPage(0);
    return _this;
  }
  _inherits(BlitzSplashScreenDesktop, _CustomPixiContainer);
  return _createClass(BlitzSplashScreenDesktop);
}(_pixiGame.CustomPixiContainer);
//# sourceMappingURL=BlitzSplashScreenDesktop.js.map